const ProductDetail = {
  options: {
    data: {},
    customization: {},
    widgets: {
      Menu_ImageSettings: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'imageSettings',
        },
        options: {
          productImageHeight: {
            data: {
              max: 450,
              min: 80,
              step: 1,
            },
            type: 'RangePx',
          },
          backgroundSize: {
            type: 'Radio',
            order: 2,
            data: {
              direction: 'row',
              radioOptions: ['cover', 'contain', 'stretch'],
            },
          },
        },
      },
      Menu_ImageTitleSettings: {
        type: 'Menu',
        order: 200,
        renderOptions: {
          controlKey: 'imageTitleSettings',
        },
        options: {
          imageTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 3,
          },
          imageTextColor: {
            type: 'HexColor',
            order: 4,
          },
          imageTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 5,
          },
          imageTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 6,
          },
          shareIcon: {
            type: 'IconSelector',
            data: {
              defaultIcon:
                'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504187_0678e2f1-3319-4a5b-b089-6d9ae7df7031.png',
            },
            order: 7,
          },
          shareIconColor: {
            type: 'HexColor',
            order: 8,
          },
        },
      },
      Menu_FavoriteSettings: {
        type: 'Menu',
        order: 250,
        renderOptions: {
          controlKey: 'favoriteSettings',
        },
        options: {
          'widget.ToggleTabs_1': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'isHeartIcon',
            },
            options: {
              heartIcon: {
                type: 'IconSelector',
                data: {
                  defaultIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
                },
                order: 17,
              },
              heartIconBackgroundColor: {
                type: 'HexColor',
                order: 18,
              },
              heartIconColor: {
                type: 'HexColor',
                order: 19,
              },
              selectedHeartIconColor: {
                type: 'HexColor',
                order: 20,
              },
              heartIconWidth: {
                order: 21,
                data: {
                  max: 20,
                  min: 10,
                  step: 1,
                },
                type: 'RangePx',
              },
              heartIconBorderRadius: {
                order: 22,
                data: {
                  max: 40,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
              },
            },
          },
        },
      },
      Menu_ShareIconSettings: {
        type: 'Menu',
        order: 251,
        renderOptions: {
          controlKey: 'shareIconSettings',
        },
        options: {
          'widget.ToggleTabs_1': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'isShareIcon',
            },
            options: {
              shareIcon: {
                type: 'IconSelector',
                data: {
                  defaultIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
                },
                order: 17,
              },
              shareIconBackgroundColor: {
                type: 'HexColor',
                order: 18,
              },
              shareIconColor: {
                type: 'HexColor',
                order: 19,
              },
              shareIconWidth: {
                order: 21,
                data: {
                  max: 20,
                  min: 10,
                  step: 1,
                },
                type: 'RangePx',
              },
              shareIconBorderRadius: {
                order: 22,
                data: {
                  max: 40,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
              },
            },
          },
        },
      },
      Menu_BarcodeSettings: {
        type: 'Menu',
        order: 300,
        renderOptions: {
          controlKey: 'barcodeSettings',
        },
        options: {
          showBarcode: {
            type: 'Radio',
            order: 8,
            data: {
              direction: 'row',
              radioOptions: ['none', 'flex'],
            },
          },
          barcodeTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 9,
          },
          barcodeTextColor: {
            type: 'HexColor',
            order: 10,
          },
          barcodeTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 11,
          },
          barcodeTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 6,
          },
        },
      },
      Menu_BrandSettings: {
        type: 'Menu',
        order: 400,
        renderOptions: {
          controlKey: 'brandSettings',
        },
        options: {
          showBrandName: {
            type: 'Radio',
            order: 8,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
          brandNameTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 9,
          },
          brandNameTextColor: {
            type: 'HexColor',
            order: 10,
          },
          brandNameTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 11,
          },
          brandNameTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 6,
          },
          brandNameTextDecoration: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'underline', 'line-through'],
            },
            order: 88,
          },
        },
      },
      Menu_StarSettings: {
        type: 'Menu',
        order: 300,
        renderOptions: {
          controlKey: 'starSettings',
        },
        options: {
          isShowStar: {
            type: 'Radio',
            order: 11,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
          starSize: {
            type: 'RangePx',
            data: {
              max: 36,
              min: 6,
              step: 1,
            },
            order: 12,
          },
        },
      },
      Menu_TagBoxSettings: {
        type: 'Menu',
        order: 500,
        renderOptions: {
          controlKey: 'tagBoxSettings',
        },
        options: {
          isShowTag: {
            type: 'Radio',
            order: 1,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
          tagIconColor: {
            type: 'HexColor',
            order: 2,
          },
          tagIconSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 3,
          },
          tagBackgroundColor: {
            type: 'HexColor',
            order: 4,
          },
          tagBorderRadius: {
            data: {
              max: 40,
              min: 0,
              step: 1,
              svgType: 'border',
            },
            type: 'FourPx',
            order: 5,
          },
          tagBoxPadding: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'edge',
            },
            type: 'FourPx',
            order: 6,
          },
          tagTextSize: {
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 7,
            type: 'RangePx',
          },
          tagTextColor: {
            type: 'HexColor',
            order: 8,
          },
          tagTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 9,
          },
          tagTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 10,
          },
        },
      },
      Menu_ProductVariantColors: {
        type: 'Menu',
        order: 600,
        renderOptions: {
          controlKey: 'productVariantColors',
        },
        options: {
          colorVariant_TitleText: {
            type: 'Text',
            order: 0,
          },
          colorVariant_TitleTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 1,
          },
          colorVariant_TitleTextColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_TitleTextAlignment: {
            type: 'LeftCenterRight',
            order: 1,
          },
          colorVariant_TitleTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 1,
          },
          colorVariant_TitleTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 1,
          },
          colorVariant_BoxesPadding: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'edge',
            },
            type: 'FourPx',
            order: 1,
          },
          colorVariant_BoxesWidth: {
            type: 'RangePx',
            data: {
              max: 100,
              min: 20,
              step: 1,
            },
            order: 1,
          },
          colorVariant_BoxesHeight: {
            type: 'RangePx',
            data: {
              max: 100,
              min: 20,
              step: 1,
            },
            order: 1,
          },
          colorVariant_BoxesBorderRadius: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'border',
            },
            type: 'FourPx',
            order: 1,
          },
          colorVariant_DefaultVariantBorderColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_SelectedVariantBorderColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_DefaultTextColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_DefaultTextBackgroundColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_SelectedTextColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_SelectedTextBackgroundColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_DisplayMode: {
            type: 'Radio',
            order: 1,
            data: {
              direction: 'row',
              radioOptions: ['slide', 'grid'],
            },
          },
          colorVariant_ImageType: {
            type: 'SelectBox',
            data: {
              selectOptions: ['image', 'color', 'text'],
            },
            order: 1,
          },
          colorVariant_ShowVariantTitle: {
            type: 'Radio',
            order: 1,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
          colorVariant_VariantTitleTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 1,
          },
          colorVariant_VariantTitleTextColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_VariantTitleTextAlignment: {
            type: 'LeftCenterRight',
            order: 1,
          },
          colorVariant_VariantTitleTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 1,
          },
          colorVariant_VariantTitleTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 1,
          },
        },
      },
      Menu_ProductVariantSizes: {
        type: 'Menu',
        order: 700,
        renderOptions: {
          controlKey: 'productVariantSizes',
        },
        options: {
          textVariant_TitleText: {
            type: 'Text',
            order: 0,
          },
          textVariant_TitleTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 1,
          },
          textVariant_TitleTextColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_TitleTextAlignment: {
            type: 'LeftCenterRight',
            order: 1,
          },
          textVariant_TitleTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 1,
          },
          textVariant_TitleTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 1,
          },
          textVariant_BoxesPadding: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'edge',
            },
            type: 'FourPx',
            order: 1,
          },
          textVariant_BoxesWidth: {
            type: 'RangePx',
            data: {
              max: 100,
              min: 20,
              step: 1,
            },
            order: 1,
          },
          textVariant_BoxesHeight: {
            type: 'RangePx',
            data: {
              max: 100,
              min: 20,
              step: 1,
            },
            order: 1,
          },
          textVariant_BoxesBorderRadius: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'border',
            },
            type: 'FourPx',
            order: 1,
          },
          textVariant_DefaultVariantBackgroundColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_SelectedVariantBackgroundColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_DefaultVariantBorderColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_SelectedVariantBorderColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_DefaultVariantTextColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_SelectedVariantTextColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_DisplayMode: {
            type: 'Radio',
            order: 1,
            data: {
              direction: 'row',
              radioOptions: ['slide', 'grid'],
            },
          },
          isShowLastProduct: {
            type: 'Toggle',
            order: 100,
          },
        },
      },
      Menu_DescriptionTitleSettings: {
        type: 'Menu',
        order: 800,
        renderOptions: {
          controlKey: 'descriptionTitleSettings',
        },
        options: {
          text: {
            type: 'Text',
            order: 1,
          },
          isShowDescriptionTitle: {
            type: 'Radio',
            order: 14,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
          descriptionTitleTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 15,
          },
          descriptionTitleTextColor: {
            type: 'HexColor',
            order: 16,
          },
          descriptionTitleTextAlignment: {
            type: 'LeftCenterRight',
            order: 17,
          },
          descriptionTitleTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 19,
          },
          descriptionTitleTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 20,
          },
        },
      },
      Menu_ProductTitleSettings: {
        type: 'Menu',
        order: 900,
        renderOptions: {
          controlKey: 'productTitleSettings',
        },
        options: {
          isShowProductTitle: {
            type: 'Radio',
            order: 14,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
          productTitleTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 15,
          },
          productTitleTextColor: {
            type: 'HexColor',
            order: 16,
          },
          ProductTitleTextAlignment: {
            type: 'LeftCenterRight',
            order: 17,
          },
          ProductTitleTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 19,
          },
          ProductTitleTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 20,
          },
          isOpenDescriptionAccordion: {
            type: 'Radio',
            order: 21,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
        },
      },
      Menu_DiscountSettings: {
        type: 'Menu',
        order: 500,
        renderOptions: {
          controlKey: 'discountSettings',
        },
        options: {
          'widget.ToggleTabs_1': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'isDiscountIcon',
            },
            options: {
              discountIcon: {
                type: 'IconSelector',
                data: {
                  defaultIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
                },
                order: 30,
              },
              priceTitleText: {
                type: 'Text',
                order: 31,
              },
              discountText: {
                type: 'Text',
                order: 31,
              },
              discountTextAlignment: {
                type: 'Radio',
                order: 32,
                data: {
                  direction: 'row',
                  radioOptions: ['row', 'column'],
                },
              },
              discountIconBackgroundColor: {
                type: 'HexColor',
                order: 33,
              },
              discountIconColor: {
                type: 'HexColor',
                order: 33,
              },
              discountIconWidth: {
                order: 34,
                data: {
                  max: 20,
                  min: 0,
                  step: 1,
                },
                type: 'RangePx',
              },
              discountIconBorderRadius: {
                order: 35,
                data: {
                  max: 40,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
              },
              discountIconPadding: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'FourPx',
              },
            },
          },
        },
      },
      Menu_ProductPriceSettings: {
        type: 'Menu',
        order: 1000,
        renderOptions: {
          controlKey: 'ProductPriceSettings',
        },
        options: {
          productPriceTextSize: {
            order: 72,
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
          },
          productPriceWeight: {
            order: 73,
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
          },
          productPriceColor: {
            order: 74,
            type: 'HexColor',
          },
          productDiscountPriceTextSize: {
            order: 75,
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
          },
          productDiscountPriceWeight: {
            order: 76,
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
          },
          productDiscountPriceColor: {
            order: 77,
            type: 'HexColor',
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'ProductDetail_1',
      name: 'ProductDetail_1',
      type: 'ProductDetail',
      data: {
        text: 'Ürün Başlığı',
        images: [],
        textVariant_TitleText: '',
        colorVariant_TitleText: '',
      },
      customization: {
        starSize: '16px',
        imageTextSize: '12px',
        shareIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504187_0678e2f1-3319-4a5b-b089-6d9ae7df7031.png',
        imageTextColor: '#212121',
        imageTextStyle: 'normal',
        isShowStar: 'show',
        imageTextWeight: '400',
        showBarcode: 'none',
        tagIconSize: '12px',
        tagTextSize: '10px',
        tagIconColor: '#000000',
        tagTextColor: '#000000',
        tagTextStyle: 'normal',
        showBrandName: 'show',
        tagBoxPadding: '5px 5px 5px 5px',
        tagTextWeight: '400',
        backgroundSize: 'cover',
        barcodeTextSize: '10px',
        tagBorderRadius: '5px 5px 5px 5px',
        barcodeTextColor: '#9C9C9C',
        barcodeTextStyle: 'normal',
        barcodeTextWeight: '400',
        brandNameTextSize: '10px',
        brandNameTextColor: '#000000',
        brandNameTextStyle: 'normal',
        productImageHeight: '274px',
        tagBackgroundColor: '#f5f5f5',
        brandNameTextWeight: '600',
        isShowTag: 'show',

        colorVariant_ImageType: 'image',
        textVariant_BoxesWidth: '60px',
        colorVariant_BoxesWidth: '45px',
        textVariant_BoxesHeight: '36px',
        textVariant_DisplayMode: 'slide',
        colorVariant_BoxesHeight: '45px',
        colorVariant_DisplayMode: 'slide',
        textVariant_BoxesPadding: '0px 0px 0px 0px',
        colorVariant_BoxesPadding: '0px 0px 0px 0px',
        textVariant_TitleTextSize: '6px',
        colorVariant_TitleTextSize: '7px',
        textVariant_TitleTextColor: '#000',
        textVariant_TitleTextStyle: 'normal',
        colorVariant_TitleTextColor: '#969696',
        colorVariant_TitleTextStyle: 'normal',
        textVariant_TitleTextWeight: '400',
        colorVariant_TitleTextWeight: '400',
        colorVariant_DefaultTextColor: '#000000',
        colorVariant_ShowVariantTitle: 'show',
        textVariant_BoxesBorderRadius: '3px 3px 3px 3px',
        colorVariant_BoxesBorderRadius: '3px 3px 3px 3px',
        colorVariant_SelectedTextColor: '#000',
        textVariant_TitleTextAlignment: 'left',
        colorVariant_TitleTextAlignment: 'left',
        colorVariant_VariantTitleTextSize: '9px',
        colorVariant_VariantTitleTextColor: '#000',
        colorVariant_VariantTitleTextStyle: 'normal',
        colorVariant_VariantTitleTextWeight: '400',
        textVariant_DefaultVariantTextColor: '#000000',
        textVariant_SelectedVariantTextColor: '#000000',
        textVariant_DefaultVariantBorderColor: '#e0e0e0',
        colorVariant_DefaultVariantBorderColor: '#d6d6d6',
        colorVariant_VariantTitleTextAlignment: 'center',
        textVariant_SelectedVariantBorderColor: '#000000',
        colorVariant_DefaultTextBackgroundColor: '#ffffff',
        colorVariant_SelectedVariantBorderColor: '#000000',
        colorVariant_SelectedTextBackgroundColor: '#242424',
        textVariant_DefaultVariantBackgroundColor: '#ffffff',
        textVariant_SelectedVariantBackgroundColor: '#ffffff',

        descriptionTitleTextSize: '13px',
        descriptionTitleTextColor: '#000000',
        descriptionTitleTextStyle: 'normal',
        descriptionTitleTextWeight: '400',
        isShowDescriptionTitle: 'notShow',
        descriptionTitleTextAlignment: 'left',
        isShowProductTitle: 'show',
        productTitleTextSize: '16px',
        productTitleTextColor: '#000000',
        productTitleTextStyle: 'normal',
        productTitleTextWeight: '500',
        productTitleTextAlignment: 'left',

        isShareIcon: true,
        shareIconColor: '#000000',
        shareIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504187_0678e2f1-3319-4a5b-b089-6d9ae7df7031.png',
        shareIconBackgroundColor: '#ffffff',
        shareIconWidth: '20px',
        shareIconBorderRadius: '40px 40px 40px 40px',
        isHeartIcon: true,
        heartIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005139684.png',
        heartIconBackgroundColor: '#ffffff',
        heartIconColor: '#050505',
        selectedHeartIconColor: '#ff0000',
        heartIconWidth: '20px',
        heartIconBorderRadius: '40px 40px 40px 40px',

        productAttributes: false,
        disabledAttributes: [],
        isShowLastProduct: true,
      },
      variantData: {},
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Group_2.webp',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'ProductDetail_2',
      name: 'ProductDetail_2',
      type: 'ProductDetail',
      data: {},
      customization: {},
      variantData: {},
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Group_2.webp',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'ProductDetail_3',
      name: 'ProductDetail_3',
      type: 'ProductDetail',
      data: {},
      customization: {},
      variantData: {},
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Group_2.webp',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'ProductDetail_4',
      name: 'ProductDetail_4',
      type: 'ProductDetail',
      data: {
        text: 'Ürün Başlığı',
        images: [],
        textVariant_TitleText: '',
        colorVariant_TitleText: '',
      },
      customization: {
        starSize: '16px',
        imageTextSize: '14px',
        shareIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504187_0678e2f1-3319-4a5b-b089-6d9ae7df7031.png',
        imageTextColor: '#212121',
        imageTextStyle: 'normal',
        isShowStar: 'show',
        imageTextWeight: '600',
        showBarcode: 'none',
        tagIconSize: '12px',
        tagTextSize: '10px',
        tagIconColor: '#000000',
        tagTextColor: '#000000',
        tagTextStyle: 'normal',
        showBrandName: 'show',
        tagBoxPadding: '5px 5px 5px 5px',
        tagTextWeight: '400',
        backgroundSize: 'contain',
        barcodeTextSize: '10px',
        tagBorderRadius: '5px 5px 5px 5px',
        barcodeTextColor: '#9C9C9C',
        barcodeTextStyle: 'normal',
        barcodeTextWeight: '400',
        brandNameTextSize: '12px',
        brandNameTextColor: '#000000',
        brandNameTextStyle: 'normal',
        productImageHeight: '130px',
        tagBackgroundColor: '#f5f5f5',
        brandNameTextWeight: '400',
        isShowTag: 'notShow',

        colorVariant_ImageType: 'image',
        textVariant_BoxesWidth: '60px',
        colorVariant_BoxesWidth: '45px',
        textVariant_BoxesHeight: '36px',
        textVariant_DisplayMode: 'slide',
        colorVariant_BoxesHeight: '45px',
        colorVariant_DisplayMode: 'slide',
        textVariant_BoxesPadding: '0px 0px 0px 0px',
        colorVariant_BoxesPadding: '0px 0px 0px 0px',
        textVariant_TitleTextSize: '6px',
        colorVariant_TitleTextSize: '7px',
        textVariant_TitleTextColor: '#000',
        textVariant_TitleTextStyle: 'normal',
        colorVariant_TitleTextColor: '#969696',
        colorVariant_TitleTextStyle: 'normal',
        textVariant_TitleTextWeight: '400',
        colorVariant_TitleTextWeight: '400',
        colorVariant_DefaultTextColor: '#000000',
        colorVariant_ShowVariantTitle: 'show',
        textVariant_BoxesBorderRadius: '3px 3px 3px 3px',
        colorVariant_BoxesBorderRadius: '3px 3px 3px 3px',
        colorVariant_SelectedTextColor: '#000',
        textVariant_TitleTextAlignment: 'left',
        colorVariant_TitleTextAlignment: 'left',
        colorVariant_VariantTitleTextSize: '9px',
        colorVariant_VariantTitleTextColor: '#000',
        colorVariant_VariantTitleTextStyle: 'normal',
        colorVariant_VariantTitleTextWeight: '400',
        textVariant_DefaultVariantTextColor: '#000000',
        textVariant_SelectedVariantTextColor: '#000000',
        textVariant_DefaultVariantBorderColor: '#e0e0e0',
        colorVariant_DefaultVariantBorderColor: '#d6d6d6',
        colorVariant_VariantTitleTextAlignment: 'center',
        textVariant_SelectedVariantBorderColor: '#000000',
        colorVariant_DefaultTextBackgroundColor: '#ffffff',
        colorVariant_SelectedVariantBorderColor: '#000000',
        colorVariant_SelectedTextBackgroundColor: '#242424',
        textVariant_DefaultVariantBackgroundColor: '#ffffff',
        textVariant_SelectedVariantBackgroundColor: '#ffffff',

        descriptionTitleTextSize: '13px',
        descriptionTitleTextColor: '#000000',
        descriptionTitleTextStyle: 'normal',
        descriptionTitleTextWeight: '400',
        isShowDescriptionTitle: 'notShow',
        descriptionTitleTextAlignment: 'left',
        isShowProductTitle: 'show',
        productTitleTextSize: '16px',
        productTitleTextColor: '#000000',
        productTitleTextStyle: 'normal',
        productTitleTextWeight: '500',
        productTitleTextAlignment: 'left',

        isShareIcon: false,
        shareIconColor: '#000000',
        shareIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504187_0678e2f1-3319-4a5b-b089-6d9ae7df7031.png',
        shareIconBackgroundColor: '#ffffff',
        shareIconWidth: '20px',
        shareIconBorderRadius: '40px 40px 40px 40px',
        isHeartIcon: false,
        heartIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005139684.png',
        heartIconBackgroundColor: '#ffffff',
        heartIconColor: '#050505',
        selectedHeartIconColor: '#ff0000',
        heartIconWidth: '20px',
        heartIconBorderRadius: '40px 40px 40px 40px',

        productAttributes: false,
        disabledAttributes: [],

        brandNameTextDecoration: 'underline',
        isDiscountIcon: true,
        discountIconBackgroundColor: '#F04F36',
        discountIconColor: '#FFFFFF',
        discountIconWidth: '9px',
        discountIconBorderRadius: '2px 2px 2px 2px',
        discountText: 'MEMBERS SAVE',
        productPriceTextSize: '15px',
        productPriceWeight: '500',
        productPriceColor: '#CD4A36',
        productDiscountPriceTextSize: '13px',
        productDiscountPriceWeight: '500',
        productDiscountPriceColor: '#6e6e6e',
        priceTitleText: 'Online Member Price',
      },
      variantData: {},
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Group_2.webp',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'ProductDetail_Yenir',
      name: 'ProductDetail_Yenir',
      type: 'ProductDetail',
      data: {},
      customization: {},
      variantData: {},
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/ProductDetail_Yenir.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'ProductDetail_HicretKuruyemis',
      name: 'ProductDetail_HicretKuruyemis',
      type: 'ProductDetail',
      data: {},
      customization: {},
      variantData: {},
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Group_2.webp',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
  ],
};
export default ProductDetail;
